import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DetalleMaterialesComponent } from '../detalle-materiales/detalle-materiales.component';
import { MaterialCompuesto } from 'src/app/shared/models/material-compuesto';
import { Material } from 'src/app/shared/models/material';
import { Subject } from 'rxjs';
import { ApiCallService } from 'src/app/core/services/api-call.service';
import { takeUntil } from 'rxjs/operators';
import { HelperClassService } from 'src/app/core/services/clase-utilidades.services';
import { Constanst } from 'src/app/core/constants/constans.component';

@Component({
  selector: 'app-gestion-mat-compuestos',
  templateUrl: './gestion-mat-compuestos.component.html',
  styleUrls: ['./gestion-mat-compuestos.component.css']
})
export class GestionMatCompuestosComponent implements OnInit {
  displayedColumns: string[] = ['reference', 'date', 'description', 'unit', 'price', 'waste', 'addedValue',
    'materialGrouping', 'supplierName', 'commentary', 'materialFamily'];
  displayedColumnsSimples: string[] = ['reference', 'description', 'unit', 'quantity', 'desp', 'price', 'totalPrice'];

  filterColumForm = new FormGroup({
    filterDetails: new FormControl('0'),
    descriptionFilter: new FormControl('', [Validators.minLength(3), Validators.maxLength(100)]),
  });
  filterSearchForm = new FormGroup({
    descriptionSearch: new FormControl('', [Validators.minLength(3), Validators.maxLength(100)]),
  });
  clickedRows = new Set<MaterialCompuesto>();
  filterNoSelected: boolean = false;
  messageError: string;
  filterDictionary = new Map<string | null, string | null>();
  referenciaCompuesto: string = "(clic en tabla)";
  isVisibleDiv: boolean = true;

  private method: string;
  private route: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();

  dataSource = new MatTableDataSource<Material>;
  dataSourceFilters = new MatTableDataSource<Material>;
  dataSourceSimples = new MatTableDataSource<any>;

  @ViewChild('paginator') paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  totalItemsPage: number;
  dataListMaterial: Material[];
  disableButtonfilter: boolean = true;
  disableButtonSearch: boolean = false;
  typeAction: string;

  xpandDisabled = true;
  defaultFilterDetails = 'description';
  classFlag: boolean = false;

  constructor(
    public dialogDetalleMaterial: MatDialog,
    private apiCallService: ApiCallService,
    private helperClassService: HelperClassService,
  ) {}

  ngOnInit(): void {
    this.classFlag = this.helperClassService.validateViewMobileScreen(screen.width);
    this.filterColumForm.get('filterDetails')!.setValue(this.defaultFilterDetails);
    this.getAllMaterial();
    this.cleanFilter();
  }

  ngAfterViewInit() {
    this.dataSourceFilters.paginator = this.paginator;
    this.paginator.page.subscribe(() => {
      if (this.typeAction == 'filterColum') {
        this.applyFilterDetails();
      } else if (this.typeAction == 'filterSearch') {
        this.applyFilter();
      } else {
        this.getAllMaterial();
      }
    });
    this.dataSourceFilters.sort = this.sort;
  }

  applyFilter() {
    if (this.filterSearchForm.invalid) {
      return;
    } else {
      this.typeAction = 'filterSearch';
      let filterValue = this.filterSearchForm.controls['descriptionSearch'].value;
      if (filterValue?.trim() != '') {
        let listFilterValue = filterValue?.trim().split(/\s/);
        if (listFilterValue?.length! <= 5) {
          this.route = '/getAllMaterialGeneralPage';
          this.method = 'POST';
          let data = {
            idTypeMaterial: 2,
            year: Number(localStorage.getItem(Constanst.STORAGE_DATA_ANIOCONSULT) ? localStorage.getItem(Constanst.STORAGE_DATA_ANIOCONSULT) : new Date().getFullYear()),
            month: Number(localStorage.getItem(Constanst.STORAGE_DATA_MONTHCONSULT) ? Number(localStorage.getItem(Constanst.STORAGE_DATA_MONTHCONSULT)) : (new Date().getMonth() + 1)),
            page: (this.paginator ? (this.paginator.pageIndex) : 0),
            pageSize: (this.paginator ? this.paginator.pageSize : 25),
            searchMaterial: filterValue?.trim()
          }

          this.apiCallService.call$(data, this.route, this.method, true, '', true)
            .pipe(takeUntil(this.destroy$)).subscribe(response => {
              if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
                this.totalItemsPage = response.data.total;
                this.dataListMaterial = response.data.content;
                this.dataSourceFilters = new MatTableDataSource(this.dataListMaterial);
              } else {
                this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
              }
              this.apiCallService.hideSpinner();
            }
            );
        } else {
          this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_FILTER_SEARCH_LIMIT, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
        }
      } else {
        this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_VALUE_EMPTY, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
      }
    }
  }

  applyFilterDetails() {
    if (this.filterColumForm.invalid) {
      return;
    } else {
      this.typeAction = 'filterColum';
      let typeSearchValue = -1;
      let filterValue = this.filterColumForm.controls['descriptionFilter'].value;
      if (filterValue?.trim() != '') {
        let listFilterValue = filterValue?.trim().split(/\s/);
        if (listFilterValue?.length! <= 5) {
          let typeSearch = this.filterColumForm.controls['filterDetails'].value;
          if (typeSearch === 'materialGrouping') { typeSearchValue = 0 }
          if (typeSearch === 'description') { typeSearchValue = 1 }
          if (typeSearch === 'reference') { typeSearchValue = 2 }

          this.route = '/getAllMaterialCustomizedPage';
          this.method = 'POST';
          let data = {
            idTypeMaterial: 2,
            year: Number(localStorage.getItem(Constanst.STORAGE_DATA_ANIOCONSULT) ? localStorage.getItem(Constanst.STORAGE_DATA_ANIOCONSULT) : new Date().getFullYear()),
            month: Number(localStorage.getItem(Constanst.STORAGE_DATA_MONTHCONSULT) ? Number(localStorage.getItem(Constanst.STORAGE_DATA_MONTHCONSULT)) : (new Date().getMonth() + 1)),
            page: (this.paginator ? (this.paginator.pageIndex) : 0),
            pageSize: (this.paginator ? this.paginator.pageSize : 25),
            typeSearchMaterial: typeSearchValue,
            searchMaterial: filterValue?.trim()
          }

          this.apiCallService.call$(data, this.route, this.method, true, '', true)
            .pipe(takeUntil(this.destroy$)).subscribe(response => {
              if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
                this.totalItemsPage = response.data.total;
                this.dataListMaterial = response.data.content;
                this.dataSourceFilters = new MatTableDataSource(this.dataListMaterial);
              } else {
                this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
              }
              this.apiCallService.hideSpinner();
            }
            );
        } else {
          this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_FILTER_SEARCH_LIMIT, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
        }
      } else {
        this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_VALUE_EMPTY, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
      }
    }
  }


  verDetalle(row: MaterialCompuesto) {
    this.dialogDetalleMaterial.open(DetalleMaterialesComponent, {
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      // disableClose: true,
      data: { simple: false, row, nroRegistro: this.totalItemsPage, dialogTitle: 'Consultando Materiales Compuestos' }
    });
  }

  cleanFilter() {
    this.filterColumForm.get('descriptionFilter')?.setValue('');
    this.filterSearchForm.get('descriptionSearch')?.setValue('');
    if (this.filterColumForm.get('filterDetails')?.value === '0') {
      this.filterColumForm.get('descriptionFilter')?.disable();
      this.disableButtonfilter = true;
      this.filterSearchForm.get('descriptionSearch')?.enable();
      this.disableButtonSearch = false;
      if (this.paginator) { this.paginator.pageIndex = 0; }
      this.getAllMaterial();
    } else {
      this.filterColumForm.get('descriptionFilter')?.enable();
      this.disableButtonfilter = false;
      this.filterSearchForm.get('descriptionSearch')?.disable();
      this.disableButtonSearch = true;
    }
  }

  verMaterialesSimples(row: MaterialCompuesto) {
    this.route = '/getAllMaterialInOneCompoundById';
    this.method = 'POST';

    let data = {
      idCompoundMaterial: row.id
    }
    this.apiCallService.call$(data, this.route, this.method, true, '', false)
    .pipe(takeUntil(this.destroy$)).subscribe(
      response => {
        //console.log(response);
        this.dataSourceSimples = new MatTableDataSource(response.data);
        this.dataSourceSimples = response.data;
        this.referenciaCompuesto = row.reference;
        this.xpandDisabled = false;
      }
    );
  }

  getAllMaterial() {
    this.route = '/getAllMaterialByDatePage';
    this.method = 'POST';
    this.totalItemsPage = 0;
    this.typeAction = 'filterAll';

    let data = {
      idTypeMaterial: 2,
      year: Number(localStorage.getItem(Constanst.STORAGE_DATA_ANIOCONSULT) ? localStorage.getItem(Constanst.STORAGE_DATA_ANIOCONSULT) : new Date().getFullYear()),
      month: Number(localStorage.getItem(Constanst.STORAGE_DATA_MONTHCONSULT) ? Number(localStorage.getItem(Constanst.STORAGE_DATA_MONTHCONSULT)) : (new Date().getMonth() + 1)),
      page: (this.paginator ? (this.paginator.pageIndex) : 0),
      pageSize: (this.paginator ? this.paginator.pageSize : 25)
    }

    this.apiCallService.call$(data, this.route, this.method, true, '', true)
    .pipe(takeUntil(this.destroy$)).subscribe(
      response => {
        if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
          this.totalItemsPage = response.data.total;
          this.dataListMaterial = response.data.content;
          this.dataSourceFilters = new MatTableDataSource(this.dataListMaterial);
        } else {
          this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
        }
        this.apiCallService.hideSpinner();
      }
    );
  }

  hideDiv() {
    this.isVisibleDiv = false;
  }

  resetPaginator(event: Event) {
    let filterValue = (event.target as HTMLInputElement).value.trim();
    if (filterValue == '') {
      this.paginator.pageIndex = 0;
      this.getAllMaterial();
    }
  }

}
